import { getAll } from '@/api/campagne/index';
import getPiecesJointeLogoByIds from '@/services/piecesJointes/getPiecesJointeLogoByIds';
import * as allTypes from '@/store/mutation-type';
import genererCritereRecherche from '@/services/bodac/campagne/genererCritereRecherche';
import * as types from './campagne-mutation-type';

function initialState() {
  return {
    items: [],
    totalCount: 0,
    criteresRecherche: genererCritereRecherche(),
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_ITEMS](state, items) {
    state.items = items;
  },
  [types.SET_TOTAL_COUNT](state, count) {
    state.totalCount = count;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
  [types.SET_CRITERE](state, critere) {
    state.criteresRecherche = critere;
  },
};

const actions = {
  async loadCampagne({ commit }, data) {
    const response = await getAll(data);
    response.data.result.items.forEach((item) => {
      item.selected = false;
    });
    if (!data.withoutImage) await getPiecesJointeLogoByIds(response.data.result.items);
    commit(types.SET_TOTAL_COUNT, response.data.result.totalCount);
    commit(types.SET_ITEMS, response.data.result.items);
    return {};
  },
};

const getters = {
  items: state => {
    return state.items;
  },
  totalCount: state => {
    return state.totalCount;
  },
  criteresRecherche: state => {
    return state.criteresRecherche;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
